import {GET_DENTIST_DETAILS_FAILURE, GET_DENTIST_DETAILS_REQUEST, GET_DENTIST_DETAILS_SUCCESS} from "./constants";

export function getDentistDetails(dentistId) {
    return {
        type: GET_DENTIST_DETAILS_REQUEST,
        data: {dentistId}
    }
}

export function getDentistDetailsSuccess(response) {
    return {
        type: GET_DENTIST_DETAILS_SUCCESS,
        data: response
    }
}

export function getDentistDetailsFailure() {
    return {
        type: GET_DENTIST_DETAILS_FAILURE,
        data: {}
    }
}



// WEBPACK FOOTER //
// ./src/containers/Layouts/Admin/DentistDetails/actions.js